import React from "react";
import {
  FiCode,
  FiDatabase,
  FiDollarSign,
  FiCheck,
} from "react-icons/fi";

import "./HorizontalBanner.css";

const results = [
  {
    value: "4.9",
    label: "Average Rating",
    icon: <FiCode />,
  },
  {
    value: "300+",
    label: "Projects Managed",
    icon: <FiDatabase />,
  },
  {
    value: "$30 M",
    label: "Ad Spend Managed",
    icon: <FiDollarSign />,
  },
  {
    value: "90%",
    label: "Success Ratio",
    icon: <FiCheck />,
  },
];

const ResultsSection = () => {
  return (
    <section className="performance-section">
      <div className="performance-container">

        <p className="performance-eyebrow">
          PROVEN RESULTS THAT SPEAK VOLUMES
        </p>

        <div className="performance-grid">

          {results.map((result, index) => (
            <div className="performance-card" key={index}>

              <div className="performance-top">

                {result.verified ? (
                  <div className="performance-verified">
                    <FiCheck />
                  </div>
                ) : (
                  <h3>{result.value}</h3>
                )}

                <div className="performance-icon">
                  {result.icon}
                </div>

              </div>

              <p className="performance-label">
                {result.label}
              </p>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default ResultsSection;